import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { useEffect, useMemo, useRef } from 'react'
import { TotalStatistics } from './total-statistics'
import { LegalStatistics } from './legal-statistics'
import { FizStatistics } from './fiz-statistics'
import { fetchDailyStatistics, fetchDiscountAggregates, fetchMonthlyStatistics, fetchPartnerStatistics, selectCurrentPartner, selectDailyStatisticsFirstLoad, selectEndDate, selectMonthlyStatisticsFirstLoad, selectPartnerDiscountAggregatesFirstLoad, selectPartnerStatisticsFirstLoad, selectStartDate } from '../model'
import { PageSubtitle } from '@/shared/ui/page-subtitle'
import { CountDiscounts } from './count-discounts'
import { SumDiscounts } from './sum-discounts'
import { DailyRevenue } from './daily-revenue'
import { MonthlyRevenue } from './monthly-revenue'
import { StatisticsFilters } from './statistics-filters'

export const PartnerSales = () => {
    const dispatch = useAppDispatch()
    const isFirstRender = useRef<boolean>(true)
    const isStatisticsFirstLoad = useAppSelector(selectPartnerStatisticsFirstLoad)
    const isDiscountAggregatedFirstLoad = useAppSelector(selectPartnerDiscountAggregatesFirstLoad)
    const isDailyStatisticsFirstLoad = useAppSelector(selectDailyStatisticsFirstLoad)
    const isMonthlyStatisticsFirstLoad = useAppSelector(selectMonthlyStatisticsFirstLoad)
    const selectedPartner = useAppSelector(selectCurrentPartner)
    const startDate = useAppSelector(selectStartDate)
    const endDate = useAppSelector(selectEndDate)

    const showDailyStatistics = useMemo(() => {
        if (!endDate) return true
        if (endDate?.getTime() - startDate?.getTime() > 31 * 24 * 60 * 60 * 1000) {
            return false
        }
        return true
    }, [endDate])

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchMonthlyStatistics())
            dispatch(fetchPartnerStatistics())
            if (endDate && startDate && ((endDate.getTime() - startDate.getTime()) < 31 * 24 * 60 * 60 * 1000)) {
                dispatch(fetchDailyStatistics())
            }
            dispatch(fetchDiscountAggregates())
        }
    }, [selectedPartner, endDate, startDate])

    useEffect(() => {
        if (isStatisticsFirstLoad) {
            dispatch(fetchPartnerStatistics())
        }
        if (isDiscountAggregatedFirstLoad) {
            dispatch(fetchDiscountAggregates())
        }
        if (isDailyStatisticsFirstLoad) {
            dispatch(fetchDailyStatistics())
        }
        if (isMonthlyStatisticsFirstLoad) {
            dispatch(fetchMonthlyStatistics())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className='flexbox'>
            <div className='flexbox'>
                <PageSubtitle title='Статистика продаж' />
                <StatisticsFilters />
                <div className='grid grid-cols-12 gap-4'>
                    <div className='col-span-12 xxl:col-span-4'>
                        <TotalStatistics />
                    </div>
                    <div className='col-span-12 xl:col-span-6 xxl:col-span-4'>
                        <LegalStatistics />
                    </div>
                    <div className='col-span-12 xl:col-span-6 xxl:col-span-4'>
                        <FizStatistics />
                    </div>
                </div>
            </div>
            <div className='flexbox'>
                <PageSubtitle title={'Выручка'}>
                    <div className='grid grid-cols-12 gap-4'>
                        {showDailyStatistics
                            ? <>
                                <div className='col-span-12 xxl:col-span-6'>
                                    <MonthlyRevenue />
                                </div>
                                <div className='col-span-12 xxl:col-span-6'>
                                    <DailyRevenue />
                                </div>
                            </>
                            : <div className='col-span-12'>
                                <MonthlyRevenue />
                            </div>
                        }
                    </div>
                </PageSubtitle>
            </div>
            <div className='flexbox'>
                <PageSubtitle title={'Скидки'}>
                    <div className='grid grid-cols-12 gap-4'>
                        <div className='col-span-6'>
                            <CountDiscounts />
                        </div>
                        <div className='col-span-6'>
                            <SumDiscounts />
                        </div>
                    </div>
                </PageSubtitle>
            </div>
        </div>
    )
}